import React from 'react';
import { Image, Typography } from 'antd';
import ResilientAntImage from '../ResilientImage/ResilientAntImage';
import './PhotoDetail.css';

const { Title, Paragraph } = Typography;

function getGalleryClassName(count) {
    if (count === 1) return 'photo-gallery photo-gallery--1';
    if (count === 2) return 'photo-gallery photo-gallery--2';
    if (count === 3) return 'photo-gallery photo-gallery--3';
    if (count === 4) return 'photo-gallery photo-gallery--4';
    return 'photo-gallery photo-gallery--masonry';
}

function PhotoItem({ pic, title, index }) {
    return (
        <div className="photo-item">
            <ResilientAntImage
                src={pic.src}
                alt={pic.description || `${title} ${index + 1}`}
                className="detail-image"
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding="async"
                placeholder={
                    <div className="detail-image-placeholder" aria-hidden="true" />
                }
            />
            {pic.description ? (
                <Paragraph className="photo-description">{pic.description}</Paragraph>
            ) : null}
        </div>
    );
}

const PhotoDetail = ({ title, description, pics }) => {
    const galleryPics = Array.isArray(pics) ? pics : [];

    return (
        <div className="photo-detail-container">
            <Typography>
                <Title level={2}>{title}</Title>
                <Paragraph className="description">{description}</Paragraph>
            </Typography>

            <Image.PreviewGroup>
                <div
                    className={getGalleryClassName(galleryPics.length)}
                    data-photo-count={galleryPics.length}
                >
                    {galleryPics.map((pic, index) => (
                        <PhotoItem
                            key={`${pic?.src ?? 'photo'}-${index}`}
                            pic={pic}
                            title={title}
                            index={index}
                        />
                    ))}
                </div>
            </Image.PreviewGroup>
        </div>
    );
};

export default PhotoDetail;
